import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';
import en from './locales/en/translation.json';
import ar from './locales/ar/translation.json';
// import more as needed

const countryToLang = {
  us: 'en',
  in: 'en',
  ae: 'ar', // Added Arabic for UAE
};

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  // Add other languages
};

const detectUserLanguage = async () => {
  try {
    const browserLang = navigator.language.split('-')[0];
    const supportedLanguages = Object.values(countryToLang);
    console.log(browserLang);
    if (supportedLanguages.includes(browserLang)) return browserLang;

    const response = await axios.get('https://ip-api.com/json');
    const countryCode = response.data.countryCode.toLowerCase();
    return countryToLang[countryCode] || 'en';
  } catch (error) {
    console.error('Language detection failed:', error);
    return 'en';
  }
};

detectUserLanguage().then((defaultLang) => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: defaultLang,
      debug: true,
      interpolation: { escapeValue: false },
      detection: {
        order: ['querystring', 'cookie', 'localStorage', 'navigator'],
        caches: ['localStorage', 'cookie'],
      },
    });
});

export default i18n;
